import React, { useState, useEffect, useRef } from "react";
import Header from "../Header/Header";

import Sidebar from "../Sidebar/Sidebar";
import $ from "jquery";

const Wraper = () => {
  const roles = JSON.parse(localStorage.getItem("user_role"));
  const themeData = localStorage.getItem("theme");

  const [toggleChatBox, setToggleChatBox] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(true);

  const ShowChatBox = () => {
    setToggleChatBox(!toggleChatBox);
  };
  const ShowSidebar = () => {
    setToggleSidebar(!toggleSidebar);
  };

  return (
    <>
      <div id="main-wrapper" className={`${toggleSidebar ? "show" : ""}`}>
        <Header ChatBox={ShowChatBox} ShowSidebar={ShowSidebar} />
        <Sidebar ShowSidebar={ShowSidebar} />
      </div>
    </>
  );
};

export default Wraper;
